<template>
  <div class="Footer_boxs">
    <div class="heardes" v-if="!meta.showFooterTab">
      <div class="hearde_Box">
        <div v-for="(item, index) in List" :key="index" class="hearde_Item">
          <img :src="item.Icon" alt="" class="hearde_Img" />
          <div class="hearde_Name">{{ item.Title }}</div>
          <div class="hearde_Describe">{{ item.describe }}</div>
        </div>
      </div>
    </div>
    <div class="Footers">
      <div class="FooterBox">
        <img
          class="Footers_Img"
          src="@/assets/images/home/logo_v2.png"
          alt=""
        />
        <div class="Footers_Box">
          <div class="Footers_Box_List">
            <span
              class="Footers_Box_Item"
              v-for="(item, index) in scenicSpotList"
              :key="index"
              @click="jump(item)"
              >{{ item.name }}</span
            >
          </div>
          <div class="icons_box">
            <div
              v-for="(item, index) in FooterList"
              :key="index"
              class="icons_box_item"
              @mouseenter="smallProgram(item, index, true)"
              @mouseleave="smallProgram(item, index, false)"
            >
              <img
                :src="item.Icon"
                :style="{ width: item.w, height: item.h }"
                class="Footers_Box_Img"
                alt=""
              />
              <img
                class="official"
                v-if="item.qc && item.show"
                :src="item.qc"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      FooterList: [
        {
          Icon: require('@/assets/images/home/Weibo.png'),
          w: '24px',
          h: '25px'
        },
        {
          Icon: require('@/assets/images/home/icon_xcx.png'),
          w: '24px',
          h: '25px',
          qc: require('@/assets/images/home/officialAccount.jpg'),
          show: false
        },
        {
          Icon: require('@/assets/images/home/icon_gzh.png'),
          w: '23px',
          h: '23px',
          qc: require('@/assets/images/home/smallProgram.jpg'),
          show: false
        },
        {
          Icon: require('@/assets/images/home/RedBook.png'),
          w: '38px',
          h: '25px'
        }
      ],
      scenicSpotList: [
        { name: '关于室外境教' },
        { name: '室外境教的由来' },
        { name: '联系室外境教' },
        { name: '网站地图' },
        { name: '交换链接' },
        { name: '帮助中心' },
        { name: '意见反馈' },
        { name: '《室外境教用户服务协议》' },
        { name: '《室外境教服务隐私政策》' },
        { name: '备案号：粤B2-20250059' },
        { name: '营业执照' },
        { name: '旅游资质' },
        { name: '增值电信业务经营许可证' },
        { name: '平台规则' },
        { name: 'ICP备案号：粤ICP备2024204775号-3' }
      ],
      List: [
        {
          Icon: require('@/assets/images/home/service.png'),
          Title: '服务',
          describe: '室外境教提倡责任的旅行对组织和参与者都是如此'
        },
        {
          Icon: require('@/assets/images/home/lineIcon.png'),
          Title: '线路',
          describe: '强大专业的策动和组织能力纯净羔妙的旅游线路'
        },
        {
          Icon: require('@/assets/images/home/experience.png'),
          Title: '体验',
          describe: '边走边玩，一路行摄，团队建设，气氛活跃'
        },
        {
          Icon: require('@/assets/images/home/ecology.png'),
          Title: '生态',
          describe: '珍惜环境，尊重风俗，注重环保，绿色旅行'
        },
        {
          Icon: require('@/assets/images/home/shareIcon.png'),
          Title: '分享',
          describe: '一次活动大量照片游记分享领队负责集体照'
        },
        {
          Icon: require('@/assets/images/home/purpose.png'),
          Title: '宗旨',
          describe: '热忱的服务团队，敬业并富有人格魅力的领队导游'
        }
      ]
    }
  },
  computed: {
    meta() {
      return this.$route.meta
    }
  },
  methods: {
    smallProgram(item, index, flag) {
      if (item.qc) {
        this.FooterList[index].show = flag
      }
    },
    jump(item) {
      if (item.name == '备案号：粤B2-20250059') {
        window.location.href =
          'https://dxzhgl.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%25E7%25B2%25A4B2-20250059&type=xuke'
      }
      if (item.name == 'ICP备案号：粤ICP备2024204775号-3') {
        window.location.href = 'https://beian.miit.gov.cn/'
      }
    }
  }
}
</script>
<style lang="less" scoped>
.Footer_boxs {
  width: 100%;
  .heardes {
    width: 100%;
    background-color: #f6f6f6;
    display: flex;
    justify-content: center;
    border-top: 2px solid #85ca9d;
    .hearde_Box {
      width: 1400px;
      height: 312px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .hearde_Item {
        width: 124px;
        .hearde_Img {
          width: 124px;
          height: 121px;
        }
        .hearde_Name {
          text-align: center;
          font-size: 15px;
          font-weight: 600;
          margin: 9px 0px;
          color: #000000;
        }
        .hearde_Describe {
          font-size: 11px;
          color: #000000;
          opacity: 0.6;
        }
      }
    }
  }

  .Footers {
    width: 100%;
    height: 270px;
    background: #128a3b;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .FooterBox {
      width: 1440px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .Footers_Img {
        width: 300px;
        height: 62px;
        margin-bottom: 32px;
      }
      .Footers_Box {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .Footers_Box_List {
          width: 1010px;
          .Footers_Box_Item {
            display: inline-block;
            font-size: 12px;
            font-weight: 400;
            color: #e7f3eb;
            margin: 0px 12px 10px 0px;
            cursor: pointer;
          }
        }
        .Footers_Box_Img {
          margin-left: 28px;
          cursor: pointer;
        }
        .official {
          width: 100px;
          height: 100px;
          position: absolute;
          bottom: 36px;
          left: -12px;
        }
        .icons_box {
          display: flex;
          align-items: center;
          .icons_box_item {
            position: relative;
          }
        }
      }
    }
  }
}
</style>
